<h2 mat-dialog-title>{{ 'AI_ASSISTANT.MCP.IMPORT' | translate }}</h2>
<mat-dialog-content>
  <mat-stepper linear="true" #stepper [labelPosition]="'bottom'">
    <mat-step [stepControl]="form.control">
      <ng-template matStepLabel>{{ 'AI_ASSISTANT.MCP.FIND_TOOLS' | translate }}</ng-template>
      <ng-template matStepContent>
        <glxy-form-field>
          <glxy-label>{{ 'AI_ASSISTANT.MCP.NAME' | translate }}</glxy-label>
          <input type="text" matInput [formControl]="form.name" />
        </glxy-form-field>
        <glxy-form-field>
          <glxy-label>{{ 'AI_ASSISTANT.MCP.URL' | translate }}</glxy-label>
          <input type="text" matInput [formControl]="form.url" />
        </glxy-form-field>
        @if (data.namespace; as ns) {
          @if (ns.globalNamespace) {
            <glxy-form-field>
              <mat-checkbox (change)="vendastaAuthChange($event.checked)" [formControl]="form.useVendastaAuth">{{
                'AI_ASSISTANT.MCP.USE_VENDASTA_AUTH' | translate
              }}</mat-checkbox>
            </glxy-form-field>
            @if (form.useVendastaAuth.value) {
              @if (scopeOptions$ | async; as scopeOptions) {
                <glxy-form-field>
                  <glxy-label>{{ 'AI_ASSISTANT.MCP.REQUIRED_SCOPES' | translate }}</glxy-label>
                  <mat-select [formControl]="form.vendastaAuthScopes" multiple>
                    <mat-option *ngFor="let scopeOption of scopeOptions" [value]="scopeOption">
                      {{ scopeOption }}
                    </mat-option>
                  </mat-select>
                </glxy-form-field>
              } @else {
                <div>{{ 'AI_ASSISTANT.MCP.LOADING_SCOPES' | translate }}</div>
              }
            }
          }
        }
        <div class="headers">
          <div class="parameters-header">
            {{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.HEADERS' | translate }}
            <mat-icon
              class="info-icon"
              [glxyTooltip]="'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.HEADERS_HELP_TEXT' | translate"
            >
              info_outline
            </mat-icon>
          </div>
          <ai-tool-header-form-array [forms]="form.headers" class="header-forms-array"></ai-tool-header-form-array>
        </div>
      </ng-template>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'AI_ASSISTANT.SHARED.SAVE' | translate }}</ng-template>
      <ng-template matStepContent>
        @if (functions?.length > 0) {
          @for (func of functions; track func; let i = $index) {
            <mat-checkbox
              [checked]="selectedFunctionIds?.has(func.id)"
              (change)="toggleFunctionSelection(func.id, $event.checked)"
            >
              <div class="list-item">
                <mat-icon class="capability-icon">offline_bolt</mat-icon>
                <div class="list-item-content">
                  <div class="list-item-title">{{ func.id }}</div>
                  <div class="list-item-description">{{ func.description }}</div>
                </div>
              </div>
            </mat-checkbox>
          }
        }
      </ng-template>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="this.dialogRef.close()">{{ 'AI_ASSISTANT.SHARED.CANCEL' | translate }}</button>
  @switch (stepper.selectedIndex) {
    @case (0) {
      <button [disabled]="!form.valid()" (click)="loadFunctions()" mat-raised-button color="primary">
        {{ 'AI_ASSISTANT.SHARED.NEXT' | translate }}
      </button>
    }
    @case (1) {
      <button color="primary" [disabled]="!functions?.length" (click)="saveMCP()" mat-raised-button>
        {{ 'AI_ASSISTANT.SHARED.SAVE' | translate }}
      </button>
    }
  }
</mat-dialog-actions>
